import React, { useContext, useState } from 'react'
import { FaCheck, FaUser } from 'react-icons/fa'
import { GrFormCheckmark } from 'react-icons/gr'
import { useHistory } from 'react-router'
import LogoNevula from '../../assets/images/logo-nevula.svg'
import Button from '../../components/General/Button'
import { ThemeContext } from '../../context/ThemeContext'

const RegisterSixth: React.FC<any> = () => {
  const [plans] = useState<any>({
    emprendedor: [
      'Clientes y proveedores',
      'Compras Básico',
      'Ventas Básico (nota de entrega y facturación sin conexión a máquina fiscal)',
      'Aplicación móvil',
      'Presupuestos',
      'Inventario (sólo 1 almacén: piso de venta)',
      'Contabilidad Básica (Ingresos, Egresos, Cuentas por Pagar, Cuentas por Cobrar)',
      'Dashboard Básico',
      'Bancos Básico (Conciliación Manual)',
    ],
    pyme: ["Clientes, proveedores y vendedores", "Compras Avanzadas (+órdenes de compra, compras concurrentes)", "Ventas Avanzada (nota de entrega y facturación con conexión a máquina fiscal)", 
          "Aplicación móvil", "Presupuestos", "Inventario 2 almacenes + compuestos ", "Contabilidad Avanzada (plan de cuentas, cuentas personalizadas) ", "Dashboard Avanzado", "Bancos y conciliación automática"],
    corporativo: ["Clientes, proveedores y vendedores", "Compras Avanzadas (+órdenes de compra, compras concurrentes)", "Aplicación móvil", "Asistente de voz", "Nómina", "Presupuestos", 
                  "Inventario ilimitado + compuestos", "Contabilidad Avanzada (plan de cuentas, cuentas personalizadas)", "Dashboard Inteligente", "Nomina", "Bancos, conciliación automática y conexión bancaria"],
  })

  const history = useHistory()

  const { theme } = useContext(ThemeContext)

  return (
    <div id="main" style={{height: '100vh'}} className="overflow-auto">
      <div className="overflow-auto flex flex-col items-center bg-white dark:bg-gray-800">
        <div className="w-full flex flex-nowrap justify-between py-10 px-14">
          <div className="w-52">
            <img src={LogoNevula} alt="zerux" />
          </div>
        </div>

        <h1>Selecciona un plan</h1>
        <Button type='outline' classes='mt-4 h-12 rounded-3xl mb-4' onClick={() => history.push("/ingresar")}>Iniciar mes de prueba gratis</Button>

        <div className="flex justify-between" style={{ width: '90%', marginBottom: 20 }}>
          {/** Card de emprendedor */}
          <div className="shadow-md bg-white dark:bg-black rounded-2xl px-10 py-12" style={{height: 500}}>
            <h1 className='text-primary-1400 dark:text-primary' style={{ fontWeight: 700, marginBottom: 5 }}>Emprendedor</h1>

            <div className="flex items-center mb-3">
              <FaUser className="mr-2 text-primary-700 dark:text-primary" />
              <label className='text-primary-700 dark:text-white'>1 Usuario</label>
            </div>

            <div>
              {plans.emprendedor.map((v) => (
                <div className="flex items-center mb-0.5">
                  <FaCheck className='text-primary-700 dark:text-primary' style={{ marginRight: 10}} />
                  <label style={{width: 336, fontWeight: 400}}>{v}</label>
                </div>
              ))}
            </div>

            <Button type='primary' classes="rounded-lg w-full mt-5 h-10" onClick={() => history.push("/registro_septimo")}>
               $10 + $1 por usuario extra
            </Button>
          </div>

          {/** Card de PYME */}
          <div className="shadow-md bg-white dark:bg-black rounded-2xl px-10 py-12" style={{height: 520}}>
            <h1 className='text-primary-1400 dark:text-primary' style={{ fontWeight: 700, marginBottom: 5  }}>PYME</h1>

            <div className="flex items-center mb-3">
              <FaUser className="mr-2 text-primary-700 dark:text-primary" />
              <FaUser className="mr-2 text-primary-700 dark:text-primary" />
              <FaUser className="mr-2 text-primary-700 dark:text-primary" />
              <label className='text-primary-700 dark:text-white'>3 Usuarios</label>
            </div>

            <div>
              {plans.pyme.map((v) => (
                <div className="flex items-center mb-0.5">
                  <FaCheck className='text-primary-700 dark:text-primary' style={{ marginRight: 10}} />
                  <label style={{width: 336, fontWeight: 400}}>{v}</label>
                </div>
              ))}
            </div>

            <label className='flex justify-center mt-10' style={{color: theme === 'dark' ? '#228B22' : "#0A6819", fontWeight: 700}}>!Próximamente!</label>

          </div>
          
          {/** Card de CORPORATIVO */}
          <div className="shadow-md bg-white dark:bg-black rounded-2xl px-10 py-12" style={{height: 550}}>
            <h1 className='text-primary-1400 dark:text-primary' style={{ fontWeight: 700 }}>Corporativo</h1>

            <div className="flex items-center mb-3">
              <FaUser  className="mr-2 text-primary-700 dark:text-primary" />
              <FaUser className="mr-2 text-primary-700 dark:text-primary" />
              <FaUser className="mr-2 text-primary-700 dark:text-primary" />
              <FaUser className="mr-2 text-primary-700 dark:text-primary" />
              <FaUser className="mr-2 text-primary-700 dark:text-primary" />
              <label className='text-primary-700 dark:text-white'>5 Usuarios</label>
            </div>

            <div>
              {plans.corporativo.map((v) => (
                <div className="flex items-center mb-0.5">
                  <FaCheck className='text-primary-700 dark:text-primary' style={{ marginRight: 10}} />
                  <label style={{width: 336, fontWeight: 400}}>{v}</label>
                </div>
              ))}
            </div>

            <label className='flex justify-center mt-8' style={{color: theme === 'dark' ? '#228B22' : "#0A6819", fontWeight: 700}}>!Próximamente!</label>

          </div>
        </div>


      </div>
    </div>
  )
}

export default RegisterSixth
